<template>
    <div ref="container" class="c-collapsible-view">
        <slot v-if="isVisible" />
    </div>
</template>

<script>
import { isString } from "lodash";
import Vue from "vue";
import inputEventBus from '@/mixins/input-eventbus';
export default {
    data() {
        return {
            isVisible: false,
            filters: [],
        };
    },
    props: {
        show: { type: Boolean, default: true },
        name: {
            type: String,
            required: true,
        },
        ariaLive: {
            type: String,
        }
    },
    mounted() {
        this.isVisible = this.show;
        if(isString(this.name)) {
            inputEventBus.$on(`toggle-for:${this.name}`, (value, el) => {
                this.isVisible = value;
            })
        }
        if(this.ariaLive) {
            this.$refs['container'].setAttribute('aria-live', this.ariaLive);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/app/components/aha-collapsable-view.vue